import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import alertify from 'alertifyjs'
import { dataFromDom } from '../src/lib/utils'
import io from 'socket.io-client'
import router from '../src/router'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {},
    notifications: [],
    serverAuth: false,
    routerAuth: false,
    session: {},
    plan: {},//current active plan
    pricing: [],
    discounts:[],
    pending: [],
    transactionStatus: [],
    renewing: false,
    currentPath:'session',
    locations:[],
    sessionId: '',
    images:[]
  },
  //
  getters: {
    notificationsNotSeen: function (state) {
      var result = 0
      if (state.notifications && state.notifications.length) {
        result = state.notifications.filter(function (val) { return !val.seen }).length
      }
      return result
    },
    isLoggedIn: function (state) {
      return state.serverAuth
    },
    filteredImages: state =>{
      return state.images.filter(image =>{
        console.log("called")
        return image
      })
    },
    userId: function (state) {
      return state.user.userName;
    }
  },
  //
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setNotifications(state, notifications) {
      state.notifications = notifications
    },
    addNotification(state, notification) {
      state.notifications.push(notification)
    },
    routerAuth(state, status) {
      state.routerAuth = status
    },
    serverAuth(state, status) {
      state.serverAuth = status
    },
    setSession(state, session) {
      state.session = session
    },
    setRenewing(state, status) {
      state.renewing = status
    },
    setPricings(state, pricings) {
      state.pricing = pricings
    },
    setPending(state, transaction) {
      state.pending = transaction
    },
    setTransStatus(state, transaction) {
      state.transactionStatus = transaction
    },
    setPlan(state, plan) {
      state.plan = plan
    },
    setDiscounts(state, discounts){
      state.discounts = discounts
    },
    setLocations(state, locations){
      state.locations = locations
    },
    setSessionId(state, sessionId){
      state.sessionId = sessionId
    },
    setImages(state, images){
      state.images = images
    }
    

  },
  //
  actions: {
    getUser({ commit, state,dispatch }) {
      axios.get('/api/client/')
          .then(function (response) {
        var body = response.data
        if (body.success) {
          //console.log(body.success)
          commit('setUser', body.body)
          commit('serverAuth', true)
          //console.log(state.serverAuth)
         //dispatch("getTransactionStatus")
        }
      }).catch(function (error) {
        if (error.response) {
          if (error.response.status === 401) {
            commit('routerAuth', false)
            commit('serverAuth', false)
            router.push({ name: 'login' })
          } else {
            console.log(error)
          }
        }
      })
    },
    getNotifications({ commit, state }) {
      axios.get('/api/notification/').then(function (response) {
        var body = response.data
        if (body.success) {
          var notifications = body['notifications'].sort((a, b) => !b.seen - !a.seen)
          commit('setNotifications', notifications)
        }
      }).catch(function (error) {
        if (error.response) {
          if (error.response.status === 401) {
            state.serverAuth = false
            state.routerAuth = false
            router.push({ name: 'login' })
          } else {
            console.log(error)
          }
        }
      })
    },
    deleteNotification({ commit, state, dispatch }, id) {
      axios.post('/api/notification/delete', { id: id }).then(function (response) {
        var body = response.data
        if (body.success) {
          dispatch('getNotifications')
          //  alertify.success('Message Deleted')
        }
      }).catch(function (error) {

        if (error.response) {
          if (error.response.status === 401) {
            commit('routerAuth', false)
            commit('serverAuth', false)
            router.push({ name: 'login' })
          } else {
            console.log(error)
            alertify.error('Error deleting message')
          }
        }
      })
    },
    readNotification({ commit }, message) {
      axios.post('/api/notification/seen', { id: message._id })
        .then(function (response) {
          var body = response.data
          if (body.success) {
            message.seen = true
          } else {
            console.log('could not mark notification as seen')
          }
        }).catch(function (error) {
          console.log(error)
        })
    },
    getSession({ commit, state, dispatch }) {
      axios.get('http://100.0.0.1/login').then(function (response) {
        var body = dataFromDom(response.data)
        commit('setSession', body)
        if (body.title === 'login') {//not logged in
          commit('routerAuth', false)
        } else if (body.title === 'alogin') {//already logged in
          dispatch('getStatus')
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    getStatus({ commit, state }) {//periodically check status
      console.log('getStatus')
      var counter = setInterval(() => {
        axios.get('http://100.0.0.1/status').then(function (response) {
          var body = dataFromDom(response.data)
          if (body.title === 'status') {
            commit('setSession', body)
            commit('routerAuth', true)
            //console.log(counter)
          } else {
            clearInterval(counter)
          }
        }).catch(function (error) {
          commit('routerAuth', false)
          clearInterval(counter)
        })
      }, 1000)
    },
    renewPlan({ commit, state,dispatch }) {
      commit('setRenewing', true)
      axios.post('/api/plan/renew', { userId: state.user._id, fromBal: true })
          .then((response) => {
        var body = response.data
        if (body.success) {
          commit('setPlan', body.plan)
          if (body.user) {
            commit('setUser', body.user)
            dispatch('routerLogin')
          }
          commit('setRenewing', false)
        } else {
          alertify.error(body.message)
          commit('setRenewing', false)
        }
      }).catch((error) => {
        commit('setRenewing', false)
        alertify.error('error occured renewing plan')
        console.log(error)
      })
    },
    getPlan({ commit, state, dispatch }) {
      axios.post('/api/plan/get', { active: true })
          .then(function (response) {
        var body = response.data
        if (body.success) {
          commit('setPlan', body.body)
          dispatch('populatePricings')
        } else {
          console.log(body.message)
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    getDiscounts({commit, state, dispatch}){
      axios.get('/api/discount/getdiscounts')
          .then((response) => {
            let body = response.data
            if (body.success){
              commit('setDiscounts', body.message)
            }

      }).catch((error) =>{
        console.log('getting discounts error', error)

      })
    },
    getLocations({commit}){
      axios.get('/api/location/getlocation')
          .then(response =>{
            let body = response.data
            if (body.success){
              commit('setLocations', body.message)
            }
          })
    },
    getImages({commit}){
      axios.get('/api/images/getActiveImages')
          .then(response =>{
            let data =response.data
            if (data.success){
              console.log(data.images)
              commit('setImages', data.images)

            }
          })
    },
    routerLogin({ commit, state, dispatch }) {
      //console.log(`username=${state.user.userName}&password=${state.user.password}`)
      /*{
        username: state.user.userName,
        password: state.user.password
      }*/
      axios
        .post(
          "http://100.0.0.1/login", `username=${state.user.userName.trim()}&password=${state.user.password}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        ).then(function (response) {
          var body = dataFromDom(response.data)
          if (body.title === 'alogin') {//success
            commit('routerAuth', true)
            dispatch('getSession')
            alertify
              .alert()
              .setting({
                transition: "zoom",
                closableByDimmer: false,
                title: "Notification",
                label: "Ok",
                message:
                  "Your account has been activated you can now access the internet"
              }).show();
          } else if (body.title === 'login') {//not successful
            commit('routerAuth', false)
            console.log(body)
            alertify
              .alert()
              .setting({
                transition: "zoom",
                closableByDimmer: false,
                title: "Error",
                label: "Ok",
                message:
                  "Error occured loging you in <br> <b> Reason: <b/> <br>" +
                  body.error
              }).show();
          }
        }).catch(function (error) {
          console.log("error")
          alertify.error('Error Occured logging in to Account');
        })
    },
    loggingOut({commit, state}){
      axios.get('/api/client/logout')
          .then(function (response) {
            if (state.routerAuth) {
              axios.get('http://100-.0.0.1/logout').then(function (res) {
                commit('routerAuth', false)
              }).catch(function (error) {
                console.log(error)
              })
            }
            commit('serverAuth', false)
            if (!status) {
              console.log('logout')
              setTimeout(function () {
                router.push('/login')
              }, 1000)

            }
          }).catch(function (error) {
        console.log(error)
      })
    },
    logOut({ commit, state, dispatch }) {
      //router.push('/login')
      console.log("user id", state.user._id)
      let params = {
        sessionId: state.sessionId,
        id: state.user._id
      }
      console.log("params", params)
      axios.post('/api/client/kick',{userName:state.user.userName},
          {withCredentials: true})
          .then((response)=>{
            let body = response.data
            if (body.success){
              alertify.success(body.message)

              axios.get(`/api/client/logout?sessionId=${state.sessionId}&id=${state.user._id}`,)
                  .then(function (response) {
                    if (state.routerAuth) {
                      axios.get('http://100.0.0.1/logout').then(function (res) {
                        commit('routerAuth', false)
                      }).catch(function (error) {
                        console.log(error)
                      })
                    }
                    commit('serverAuth', false)
                    if (!status) {
                      console.log('logout')
                      setTimeout(function () {
                        router.push('/login')
                      }, 1000)

                    }
                  }).catch(function (error) {
                console.log(error)
              })
            }else {
              alertify.warning(body.message)
              axios.get('/api/client/logout', { params: { sessionId: state.sessionId } })
                  .then(function (response) {
                    if (state.routerAuth) {
                      axios.get('http://100.0.0.1/logout').then(function (res) {
                        commit('routerAuth', false)
                      }).catch(function (error) {
                        console.log(error)
                      })
                    }
                    commit('serverAuth', false)
                    if (!status) {
                      console.log('logout')
                      setTimeout(function () {
                        router.push('/login')
                      }, 1000)

                    }
                  }).catch(function (error) {
                console.log(error)
              })
            }

            /*if(body.success){
              //kick successfull
            }else{
              //no session found
            }*/
          }).catch((error)=>{
        console.log(error)
      })

    },
    kickAccount({commit, state, dispatch}){//kick account and login
      axios.post('/api/client/kick',{userName:state.user.userName})
          .then((response)=>{
        var body = response.data
        dispatch('routerLogin')
        /*if(body.success){
          //kick successfull
        }else{
          //no session found
        }*/
      }).catch((error)=>{
        console.log(error)
      })
    },
    updateListener({ commit, state, dispatch }) {
      //connect to socket io server and listen to events and update
      var socket = io()
      socket.on('connect', function () {
        console.log('socket connected')
      })

      socket.on('notification', function (notification) {
        console.log(state.notifications)
        commit('addNotification', notification)
      })

      socket.on('activatePlan', function (plan) {//activated on pay plan
        commit('routerLogin')
        commit('setPlan', plan)
        dispatch('getUser')
      })

      socket.on('updateUser', function (user) {//activated on pay plan
        // dispatch('getUser')
        //console.log(user)
        commit('setUser', user)
        if (!state.routerAuth) {
          dispatch('routerLogin')
        } else {
          alertify
            .alert()
            .setting({
              transition: "zoom",
              closableByDimmer: false,
              title: "Notification",
              label: "Ok",
              message:
                "Payment has been received",
              onok:function(){
               // console.log('done')
              }
            }).show()
        }

      })

      socket.on('updatePending', function (transaction) {//stk transaction arives
        var transactions = state.pending
        var key = transactions.findIndex(function (val) { return val._id === transaction._id })
        if (key > 0) {
          state.pending[key] = transaction
        } else {
          state.pending.push(transaction)
        }
      })

      socket.on('updateTransStatus', function (transaction) {//transaction status arives
        var transactions = state.transactionStatus
        var key = transactions.findIndex(function (val) { return val._id === transaction._id })
        if (key > 0) {
          state.transactionStatus[key] = transaction
        } else {
          state.transactionStatus.push(transaction)
        }
      })
      socket.on('error_message', function (message) {
        console.log('socket not authorized')
      })

      socket.on('disconnect', function () {
        console.log('disconnected')
      });
    },
    populatePricings({ commit, state }) {
      axios.get('/api/pricing/').then(function (response) {
        var body = response.data
        if (body.success) {
          commit('setPricings', body.body)
          //console.log(body)

        } else {
          console.log(response)
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    populatePending({ commit, state }) {
      axios.get('/api/payment/requests').then((response) => {
        var body = response.data
        if (body.success) {
          commit('setPending', body.message)
        } else {
          console.log(body)
        }
      }).catch((error) => {
        alertify.error('Error occured getting payments')
      })
    },
    getTransactionStatus({ commit, state }) {
      axios.post('/api/payment/getstatus', { clientId: state.user._id }).then((response) => {
        var body = response.data
        console.log(body)
        if (body.success) {
          commit('setTransStatus', body.transactions)
        } else {
          //console.log(body)
        }
      }).catch((error) => {
        alertify.error('Error occured getting transactions')
      })
    },
    setUpRouting({ commit, state }) {
       state.currentPath = router.currentRoute.name
      router.beforeEach((to, from, next) => {
        if (state.serverAuth) {
          this.menuActive = false;
          state.currentPath = to.name;
          next();
        } else {
          if (to.name === "login" || from.name === "login") {
            next();
          } else {
            next({
              name: "login"
            });
          }
        }
      });
    }
  }
})
